import type { CSSProperties, FC, ReactNode } from 'react'

import Image from 'next/image'
import { cn } from '@/lib/utils'
import { TILE_SIZES } from '@/constants/media'

export interface TileLook {
    src: string
    position?: string
    zoom?: number
    mirror?: boolean
    filter?: string
}

interface MediaTileProps extends TileLook {
    motion?: boolean
    delay?: number
    drift?: [string, string]
    eager?: boolean
    className?: string
    imageStyle?: CSSProperties
}

const MediaTile: FC<MediaTileProps> = ({
    src,
    position = '50% 50%',
    zoom = 1,
    mirror = false,
    filter,
    motion = false,
    delay = 0,
    drift,
    eager = false,
    className,
    imageStyle
}): ReactNode => {
    const driftStyle = motion
        ? ({
            animationDelay: `${-delay}s`,
            '--kb-x': drift?.[0],
            '--kb-y': drift?.[1]
        } as CSSProperties)
        : undefined

    return (
        <div className={cn('absolute inset-0 overflow-hidden bg-zinc-900', mirror && '-scale-x-100', className)}>
            <div className={cn('absolute inset-0', motion && 'kenburns')} style={driftStyle}>
                <Image
                    src={src}
                    alt=''
                    fill
                    sizes={TILE_SIZES}
                    loading={eager ? 'eager' : 'lazy'}
                    draggable={false}
                    className='object-cover select-none'
                    style={{
                        objectPosition: position,
                        transform: zoom !== 1 ? `scale(${zoom})` : undefined,
                        transformOrigin: position,
                        filter,
                        ...imageStyle
                    }}
                />
            </div>
        </div>
    )
}

export default MediaTile
